/* eslint-disable import/no-duplicates */
import { format as formatDate, formatDistance, formatRelative, isDate, Locale } from 'date-fns';
import { enGB, fr } from 'date-fns/locale';
import i18next from 'i18next';
import borderCrossingRORO_applicantTransmittedDocuments_de from 'locales/de/borderCrossingRORO_applicantTransmittedDocuments.json';
import borderCrossingRORO_common_de from 'locales/de/borderCrossingRORO_common.json';
import borderCrossingRORO_crossingDocuments_de from 'locales/de/borderCrossingRORO_crossingDocuments.json';
import borderCrossingRORO_crossingInfoBanner_de from 'locales/de/borderCrossingRORO_crossingInfoBanner.json';
import borderCrossingRORO_haulierEori_de from 'locales/de/borderCrossingRORO_haulierEori.json';
import borderCrossingRORO_lifeline_de from 'locales/de/borderCrossingRORO_lifeline.json';
import borderCrossingRORO_newRequest_de from 'locales/de/borderCrossingRORO_newRequest.json';
import borderCrossingRORO_onBoarding_de from 'locales/de/borderCrossingRORO_onBoarding.json';
import borderCrossingRORO_prefolderQualification_de from 'locales/de/borderCrossingRORO_prefolderQualification.json';
import borderPassEasyWithRORO_lifeline_de from 'locales/de/borderPassEasyWithRORO_lifeline.json';
import borderPassEasyWithRORO_prefolderQualification_de from 'locales/de/borderPassEasyWithRORO_prefolderQualification.json';
import common_de from 'locales/de/common.json';
import components_de from 'locales/de/components.json';
import countries_de from 'locales/de/countries.json';
import customsPass_bookingSummary_de from 'locales/de/customsPass_bookingSummary.json';
import customsPass_common_de from 'locales/de/customsPass_common.json';
import customsPass_consentBanner_de from 'locales/de/customsPass_consentBanner.json';
import customsPass_consignments_de from 'locales/de/customsPass_consignments.json';
import customsPass_cookiesListPage_de from 'locales/de/customsPass_cookiesListPage.json';
import customsPass_crossingDocuments_de from 'locales/de/customsPass_crossingDocuments.json';
import customsPass_crossingInfoBannerSummary_de from 'locales/de/customsPass_crossingInfoBannerSummary.json';
import customsPass_customsDocuments_de from 'locales/de/customsPass_customsDocuments.json';
import customsPass_landingPage_de from 'locales/de/customsPass_landingPage.json';
import customsPass_lifeline_de from 'locales/de/customsPass_lifeline.json';
import customsPass_privacyStatementPage_de from 'locales/de/customsPass_privacyStatementPage.json';
import customsPass_securityPolicyPage_de from 'locales/de/customsPass_securityPolicyPage.json';
import customsPass_servicesOffer_de from 'locales/de/customsPass_servicesOffer.json';
import customsPass_zendeskForm_de from 'locales/de/customsPass_zendeskForm.json';
import easy_bookingSummary_de from 'locales/de/easy_bookingSummary.json';
import easy_common_de from 'locales/de/easy_common.json';
import easy_crossingDocuments_de from 'locales/de/easy_crossingDocuments.json';
import easy_crossingInfoBanner_de from 'locales/de/easy_crossingInfoBanner.json';
import easy_customsDocuments_de from 'locales/de/easy_customsDocuments.json';
import easy_lifeline_de from 'locales/de/easy_lifeline.json';
import easy_prefolder_de from 'locales/de/easy_prefolder.json';
import folders_de from 'locales/de/folders.json';
import layouts_de from 'locales/de/layouts.json';
import borderPassEasyWithRORO_crossingInfoBanner_de from 'locales/de/layouts.json';
import vehicle_types_de from 'locales/de/vehicle_types.json';
import borderCrossingRORO_applicantTransmittedDocuments_en from 'locales/en/borderCrossingRORO_applicantTransmittedDocuments.json';
import borderCrossingRORO_common_en from 'locales/en/borderCrossingRORO_common.json';
import borderCrossingRORO_crossingDocuments_en from 'locales/en/borderCrossingRORO_crossingDocuments.json';
import borderCrossingRORO_crossingInfoBanner_en from 'locales/en/borderCrossingRORO_crossingInfoBanner.json';
import borderCrossingRORO_haulierEori_en from 'locales/en/borderCrossingRORO_haulierEori.json';
import borderCrossingRORO_lifeline_en from 'locales/en/borderCrossingRORO_lifeline.json';
import borderCrossingRORO_newRequest_en from 'locales/en/borderCrossingRORO_newRequest.json';
import borderCrossingRORO_onBoarding_en from 'locales/en/borderCrossingRORO_onBoarding.json';
import borderCrossingRORO_prefolderQualification_en from 'locales/en/borderCrossingRORO_prefolderQualification.json';
import borderPassEasyWithRORO_crossingInfoBanner_en from 'locales/en/borderPassEasyWithRORO_crossingInfoBanner.json';
import borderPassEasyWithRORO_lifeline_en from 'locales/en/borderPassEasyWithRORO_lifeline.json';
import borderPassEasyWithRORO_prefolderQualification_en from 'locales/en/borderPassEasyWithRORO_prefolderQualification.json';
import common_en from 'locales/en/common.json';
import components_en from 'locales/en/components.json';
import countries_en from 'locales/en/countries.json';
import customsPass_bookingSummary_en from 'locales/en/customsPass_bookingSummary.json';
import customsPass_common_en from 'locales/en/customsPass_common.json';
import customsPass_consentBanner_en from 'locales/en/customsPass_consentBanner.json';
import customsPass_consignments_en from 'locales/en/customsPass_consignments.json';
import customsPass_cookiesListPage_en from 'locales/en/customsPass_cookiesListPage.json';
import customsPass_crossingDocuments_en from 'locales/en/customsPass_crossingDocuments.json';
import customsPass_crossingInfoBannerSummary_en from 'locales/en/customsPass_crossingInfoBannerSummary.json';
import customsPass_customsDocuments_en from 'locales/en/customsPass_customsDocuments.json';
import customsPass_landingPage_en from 'locales/en/customsPass_landingPage.json';
import customsPass_lifeline_en from 'locales/en/customsPass_lifeline.json';
import customsPass_privacyStatementPage_en from 'locales/en/customsPass_privacyStatementPage.json';
import customsPass_securityPolicyPage_en from 'locales/en/customsPass_securityPolicyPage.json';
import customsPass_servicesOffer_en from 'locales/en/customsPass_servicesOffer.json';
import customsPass_zendeskForm_en from 'locales/en/customsPass_zendeskForm.json';
import easy_bookingSummary_en from 'locales/en/easy_bookingSummary.json';
import easy_common_en from 'locales/en/easy_common.json';
import easy_crossingDocuments_en from 'locales/en/easy_crossingDocuments.json';
import easy_crossingInfoBanner_en from 'locales/en/easy_crossingInfoBanner.json';
import easy_customsDocuments_en from 'locales/en/easy_customsDocuments.json';
import easy_lifeline_en from 'locales/en/easy_lifeline.json';
import easy_prefolder_en from 'locales/en/easy_prefolder.json';
import folders_en from 'locales/en/folders.json';
import layouts_en from 'locales/en/layouts.json';
import vehicle_types_en from 'locales/en/vehicle_types.json';
import borderCrossingRORO_applicantTransmittedDocuments_es from 'locales/es/borderCrossingRORO_applicantTransmittedDocuments.json';
import borderCrossingRORO_common_es from 'locales/es/borderCrossingRORO_common.json';
import borderCrossingRORO_crossingDocuments_es from 'locales/es/borderCrossingRORO_crossingDocuments.json';
import borderCrossingRORO_crossingInfoBanner_es from 'locales/es/borderCrossingRORO_crossingInfoBanner.json';
import borderCrossingRORO_haulierEori_es from 'locales/es/borderCrossingRORO_haulierEori.json';
import borderCrossingRORO_lifeline_es from 'locales/es/borderCrossingRORO_lifeline.json';
import borderCrossingRORO_newRequest_es from 'locales/es/borderCrossingRORO_newRequest.json';
import borderCrossingRORO_onBoarding_es from 'locales/es/borderCrossingRORO_onBoarding.json';
import borderCrossingRORO_prefolderQualification_es from 'locales/es/borderCrossingRORO_prefolderQualification.json';
import borderPassEasyWithRORO_crossingInfoBanner_es from 'locales/es/borderPassEasyWithRORO_crossingInfoBanner.json';
import borderPassEasyWithRORO_lifeline_es from 'locales/es/borderPassEasyWithRORO_lifeline.json';
import borderPassEasyWithRORO_prefolderQualification_es from 'locales/es/borderPassEasyWithRORO_prefolderQualification.json';
import common_es from 'locales/es/common.json';
import components_es from 'locales/es/components.json';
import countries_es from 'locales/es/countries.json';
import customsPass_bookingSummary_es from 'locales/es/customsPass_bookingSummary.json';
import customsPass_common_es from 'locales/es/customsPass_common.json';
import customsPass_consentBanner_es from 'locales/es/customsPass_consentBanner.json';
import customsPass_consignments_es from 'locales/es/customsPass_consignments.json';
import customsPass_cookiesListPage_es from 'locales/es/customsPass_cookiesListPage.json';
import customsPass_crossingDocuments_es from 'locales/es/customsPass_crossingDocuments.json';
import customsPass_crossingInfoBannerSummary_es from 'locales/es/customsPass_crossingInfoBannerSummary.json';
import customsPass_customsDocuments_es from 'locales/es/customsPass_customsDocuments.json';
import customsPass_landingPage_es from 'locales/es/customsPass_landingPage.json';
import customsPass_lifeline_es from 'locales/es/customsPass_lifeline.json';
import customsPass_privacyStatementPage_es from 'locales/es/customsPass_privacyStatementPage.json';
import customsPass_securityPolicyPage_es from 'locales/es/customsPass_securityPolicyPage.json';
import customsPass_servicesOffer_es from 'locales/es/customsPass_servicesOffer.json';
import customsPass_zendeskForm_es from 'locales/es/customsPass_zendeskForm.json';
import easy_bookingSummary_es from 'locales/es/easy_bookingSummary.json';
import easy_common_es from 'locales/es/easy_common.json';
import easy_crossingDocuments_es from 'locales/es/easy_crossingDocuments.json';
import easy_crossingInfoBanner_es from 'locales/es/easy_crossingInfoBanner.json';
import easy_customsDocuments_es from 'locales/es/easy_customsDocuments.json';
import easy_lifeline_es from 'locales/es/easy_lifeline.json';
import easy_prefolder_es from 'locales/es/easy_prefolder.json';
import folders_es from 'locales/es/folders.json';
import layouts_es from 'locales/es/layouts.json';
import vehicle_types_es from 'locales/es/vehicle_types.json';
import borderCrossingRORO_applicantTransmittedDocuments_fr from 'locales/fr/borderCrossingRORO_applicantTransmittedDocuments.json';
import borderCrossingRORO_common_fr from 'locales/fr/borderCrossingRORO_common.json';
import borderCrossingRORO_crossingDocuments_fr from 'locales/fr/borderCrossingRORO_crossingDocuments.json';
import borderCrossingRORO_crossingInfoBanner_fr from 'locales/fr/borderCrossingRORO_crossingInfoBanner.json';
import borderCrossingRORO_haulierEori_fr from 'locales/fr/borderCrossingRORO_haulierEori.json';
import borderCrossingRORO_lifeline_fr from 'locales/fr/borderCrossingRORO_lifeline.json';
import borderCrossingRORO_newRequest_fr from 'locales/fr/borderCrossingRORO_newRequest.json';
import borderCrossingRORO_onBoarding_fr from 'locales/fr/borderCrossingRORO_onBoarding.json';
import borderCrossingRORO_prefolderQualification_fr from 'locales/fr/borderCrossingRORO_prefolderQualification.json';
import borderPassEasyWithRORO_crossingInfoBanner_fr from 'locales/fr/borderPassEasyWithRORO_crossingInfoBanner.json';
import borderPassEasyWithRORO_lifeline_fr from 'locales/fr/borderPassEasyWithRORO_lifeline.json';
import borderPassEasyWithRORO_prefolderQualification_fr from 'locales/fr/borderPassEasyWithRORO_prefolderQualification.json';
import common_fr from 'locales/fr/common.json';
import components_fr from 'locales/fr/components.json';
import countries_fr from 'locales/fr/countries.json';
import customsPass_bookingSummary_fr from 'locales/fr/customsPass_bookingSummary.json';
import customsPass_common_fr from 'locales/fr/customsPass_common.json';
import customsPass_consentBanner_fr from 'locales/fr/customsPass_consentBanner.json';
import customsPass_consignments_fr from 'locales/fr/customsPass_consignments.json';
import customsPass_cookiesListPage_fr from 'locales/fr/customsPass_cookiesListPage.json';
import customsPass_crossingDocuments_fr from 'locales/fr/customsPass_crossingDocuments.json';
import customsPass_crossingInfoBannerSummary_fr from 'locales/fr/customsPass_crossingInfoBannerSummary.json';
import customsPass_customsDocuments_fr from 'locales/fr/customsPass_customsDocuments.json';
import customsPass_landingPage_fr from 'locales/fr/customsPass_landingPage.json';
import customsPass_lifeline_fr from 'locales/fr/customsPass_lifeline.json';
import customsPass_privacyStatementPage_fr from 'locales/fr/customsPass_privacyStatementPage.json';
import customsPass_securityPolicyPage_fr from 'locales/fr/customsPass_securityPolicyPage.json';
import customsPass_servicesOffer_fr from 'locales/fr/customsPass_servicesOffer.json';
import customsPass_zendeskForm_fr from 'locales/fr/customsPass_zendeskForm.json';
import easy_bookingSummary_fr from 'locales/fr/easy_bookingSummary.json';
import easy_common_fr from 'locales/fr/easy_common.json';
import easy_crossingDocuments_fr from 'locales/fr/easy_crossingDocuments.json';
import easy_crossingInfoBanner_fr from 'locales/fr/easy_crossingInfoBanner.json';
import easy_customsDocuments_fr from 'locales/fr/easy_customsDocuments.json';
import easy_lifeline_fr from 'locales/fr/easy_lifeline.json';
import easy_prefolder_fr from 'locales/fr/easy_prefolder.json';
import folders_fr from 'locales/fr/folders.json';
import layouts_fr from 'locales/fr/layouts.json';
import vehicle_types_fr from 'locales/fr/vehicle_types.json';
import borderCrossingRORO_applicantTransmittedDocuments_nl from 'locales/nl/borderCrossingRORO_applicantTransmittedDocuments.json';
import borderCrossingRORO_common_nl from 'locales/nl/borderCrossingRORO_common.json';
import borderCrossingRORO_crossingDocuments_nl from 'locales/nl/borderCrossingRORO_crossingDocuments.json';
import borderCrossingRORO_crossingInfoBanner_nl from 'locales/nl/borderCrossingRORO_crossingInfoBanner.json';
import borderCrossingRORO_haulierEori_nl from 'locales/nl/borderCrossingRORO_haulierEori.json';
import borderCrossingRORO_lifeline_nl from 'locales/nl/borderCrossingRORO_lifeline.json';
import borderCrossingRORO_newRequest_nl from 'locales/nl/borderCrossingRORO_newRequest.json';
import borderCrossingRORO_onBoarding_nl from 'locales/nl/borderCrossingRORO_onBoarding.json';
import borderCrossingRORO_prefolderQualification_nl from 'locales/nl/borderCrossingRORO_prefolderQualification.json';
import borderPassEasyWithRORO_crossingInfoBanner_nl from 'locales/nl/borderPassEasyWithRORO_crossingInfoBanner.json';
import borderPassEasyWithRORO_lifeline_nl from 'locales/nl/borderPassEasyWithRORO_lifeline.json';
import borderPassEasyWithRORO_prefolderQualification_nl from 'locales/nl/borderPassEasyWithRORO_prefolderQualification.json';
import common_nl from 'locales/nl/common.json';
import components_nl from 'locales/nl/components.json';
import countries_nl from 'locales/nl/countries.json';
import customsPass_bookingSummary_nl from 'locales/nl/customsPass_bookingSummary.json';
import customsPass_common_nl from 'locales/nl/customsPass_common.json';
import customsPass_consentBanner_nl from 'locales/nl/customsPass_consentBanner.json';
import customsPass_consignments_nl from 'locales/nl/customsPass_consignments.json';
import customsPass_cookiesListPage_nl from 'locales/nl/customsPass_cookiesListPage.json';
import customsPass_crossingDocuments_nl from 'locales/nl/customsPass_crossingDocuments.json';
import customsPass_crossingInfoBannerSummary_nl from 'locales/nl/customsPass_crossingInfoBannerSummary.json';
import customsPass_customsDocuments_nl from 'locales/nl/customsPass_customsDocuments.json';
import customsPass_landingPage_nl from 'locales/nl/customsPass_landingPage.json';
import customsPass_lifeline_nl from 'locales/nl/customsPass_lifeline.json';
import customsPass_privacyStatementPage_nl from 'locales/nl/customsPass_privacyStatementPage.json';
import customsPass_securityPolicyPage_nl from 'locales/nl/customsPass_securityPolicyPage.json';
import customsPass_servicesOffer_nl from 'locales/nl/customsPass_servicesOffer.json';
import customsPass_zendeskForm_nl from 'locales/nl/customsPass_zendeskForm.json';
import easy_bookingSummary_nl from 'locales/nl/easy_bookingSummary.json';
import easy_common_nl from 'locales/nl/easy_common.json';
import easy_crossingDocuments_nl from 'locales/nl/easy_crossingDocuments.json';
import easy_crossingInfoBanner_nl from 'locales/nl/easy_crossingInfoBanner.json';
import easy_customsDocuments_nl from 'locales/nl/easy_customsDocuments.json';
import easy_lifeline_nl from 'locales/nl/easy_lifeline.json';
import easy_prefolder_nl from 'locales/nl/easy_prefolder.json';
import folders_nl from 'locales/nl/folders.json';
import layouts_nl from 'locales/nl/layouts.json';
import vehicle_types_nl from 'locales/nl/vehicle_types.json';
import borderCrossingRORO_applicantTransmittedDocuments_pl from 'locales/pl/borderCrossingRORO_applicantTransmittedDocuments.json';
import borderCrossingRORO_common_pl from 'locales/pl/borderCrossingRORO_common.json';
import borderCrossingRORO_crossingDocuments_pl from 'locales/pl/borderCrossingRORO_crossingDocuments.json';
import borderCrossingRORO_crossingInfoBanner_pl from 'locales/pl/borderCrossingRORO_crossingInfoBanner.json';
import borderCrossingRORO_haulierEori_pl from 'locales/pl/borderCrossingRORO_haulierEori.json';
import borderCrossingRORO_lifeline_pl from 'locales/pl/borderCrossingRORO_lifeline.json';
import borderCrossingRORO_newRequest_pl from 'locales/pl/borderCrossingRORO_newRequest.json';
import borderCrossingRORO_onBoarding_pl from 'locales/pl/borderCrossingRORO_onBoarding.json';
import borderCrossingRORO_prefolderQualification_pl from 'locales/pl/borderCrossingRORO_prefolderQualification.json';
import layouts_pl from 'locales/pl/borderPassEasyWithRORO_crossingInfoBanner.json';
import borderPassEasyWithRORO_crossingInfoBanner_pl from 'locales/pl/borderPassEasyWithRORO_crossingInfoBanner.json';
import borderPassEasyWithRORO_lifeline_pl from 'locales/pl/borderPassEasyWithRORO_lifeline.json';
import borderPassEasyWithRORO_prefolderQualification_pl from 'locales/pl/borderPassEasyWithRORO_prefolderQualification.json';
import common_pl from 'locales/pl/common.json';
import components_pl from 'locales/pl/components.json';
import countries_pl from 'locales/pl/countries.json';
import customsPass_bookingSummary_pl from 'locales/pl/customsPass_bookingSummary.json';
import customsPass_common_pl from 'locales/pl/customsPass_common.json';
import customsPass_consentBanner_pl from 'locales/pl/customsPass_consentBanner.json';
import customsPass_consignments_pl from 'locales/pl/customsPass_consignments.json';
import customsPass_cookiesListPage_pl from 'locales/pl/customsPass_cookiesListPage.json';
import customsPass_crossingDocuments_pl from 'locales/pl/customsPass_crossingDocuments.json';
import customsPass_crossingInfoBannerSummary_pl from 'locales/pl/customsPass_crossingInfoBannerSummary.json';
import customsPass_customsDocuments_pl from 'locales/pl/customsPass_customsDocuments.json';
import customsPass_landingPage_pl from 'locales/pl/customsPass_landingPage.json';
import customsPass_lifeline_pl from 'locales/pl/customsPass_lifeline.json';
import customsPass_privacyStatementPage_pl from 'locales/pl/customsPass_privacyStatementPage.json';
import customsPass_securityPolicyPage_pl from 'locales/pl/customsPass_securityPolicyPage.json';
import customsPass_servicesOffer_pl from 'locales/pl/customsPass_servicesOffer.json';
import customsPass_zendeskForm_pl from 'locales/pl/customsPass_zendeskForm.json';
import easy_bookingSummary_pl from 'locales/pl/easy_bookingSummary.json';
import easy_common_pl from 'locales/pl/easy_common.json';
import easy_crossingDocuments_pl from 'locales/pl/easy_crossingDocuments.json';
import easy_crossingInfoBanner_pl from 'locales/pl/easy_crossingInfoBanner.json';
import easy_customsDocuments_pl from 'locales/pl/easy_customsDocuments.json';
import easy_lifeline_pl from 'locales/pl/easy_lifeline.json';
import easy_prefolder_pl from 'locales/pl/easy_prefolder.json';
import folders_pl from 'locales/pl/folders.json';
import vehicle_types_pl from 'locales/pl/vehicle_types.json';

import { LANGUAGES } from '@/features/shared/constants';

export const locales: { enGB: Locale; fr: Locale } = { enGB, fr };

i18next.init({
  lng: localStorage.getItem('sherpass-language') ?? LANGUAGES.en,
  fallbackLng: LANGUAGES.en,
  supportedLngs: [LANGUAGES.fr, LANGUAGES.en, LANGUAGES.es, LANGUAGES.de, LANGUAGES.nl, LANGUAGES.pl],
  resources: {
    en: {
      common: common_en,
      layouts: layouts_en,
      folders: folders_en,
      components: components_en,
      vehicle_types: vehicle_types_en,

      // border pass easy
      easy_common: easy_common_en,
      easy_lifeline: easy_lifeline_en,
      easy_prefolder: easy_prefolder_en,
      easy_bookingSummary: easy_bookingSummary_en,
      easy_customsDocuments: easy_customsDocuments_en,
      easy_crossingDocuments: easy_crossingDocuments_en,
      easy_crossingInfoBanner: easy_crossingInfoBanner_en,
      borderPassEasyWithRORO_lifeline: borderPassEasyWithRORO_lifeline_en,
      borderPassEasyWithRORO_crossingInfoBanner: borderPassEasyWithRORO_crossingInfoBanner_en,
      borderPassEasyWithRORO_prefolderQualification: borderPassEasyWithRORO_prefolderQualification_en,

      // customs pass
      customsPass_common: customsPass_common_en,
      customsPass_lifeline: customsPass_lifeline_en,
      customsPass_landingPage: customsPass_landingPage_en,
      customsPass_zendeskForm: customsPass_zendeskForm_en,
      customsPass_consignments: customsPass_consignments_en,
      customsPass_servicesOffer: customsPass_servicesOffer_en,
      customsPass_consentBanner: customsPass_consentBanner_en,
      customsPass_bookingSummary: customsPass_bookingSummary_en,
      customsPass_cookiesListPage: customsPass_cookiesListPage_en,
      customsPass_customsDocuments: customsPass_customsDocuments_en,
      customsPass_crossingDocuments: customsPass_crossingDocuments_en,
      customsPass_securityPolicyPage: customsPass_securityPolicyPage_en,
      customsPass_privacyStatementPage: customsPass_privacyStatementPage_en,
      customsPass_crossingInfoBannerSummary: customsPass_crossingInfoBannerSummary_en,

      // borderCrossingRORO
      countries: countries_en,
      borderCrossingRORO_common: borderCrossingRORO_common_en,
      borderCrossingRORO_lifeline: borderCrossingRORO_lifeline_en,
      borderCrossingRORO_newRequest: borderCrossingRORO_newRequest_en,
      borderCrossingRORO_onBoarding: borderCrossingRORO_onBoarding_en,
      borderCrossingRORO_haulierEori: borderCrossingRORO_haulierEori_en,
      borderCrossingRORO_crossingDocuments: borderCrossingRORO_crossingDocuments_en,
      borderCrossingRORO_crossingInfoBanner: borderCrossingRORO_crossingInfoBanner_en,
      borderCrossingRORO_prefolderQualification: borderCrossingRORO_prefolderQualification_en,
      borderCrossingRORO_applicantTransmittedDocuments: borderCrossingRORO_applicantTransmittedDocuments_en,
    },
    fr: {
      common: common_fr,
      layouts: layouts_fr,
      folders: folders_fr,
      components: components_fr,
      vehicle_types: vehicle_types_fr,

      // border pass easy
      easy_common: easy_common_fr,
      easy_lifeline: easy_lifeline_fr,
      easy_prefolder: easy_prefolder_fr,
      easy_bookingSummary: easy_bookingSummary_fr,
      easy_customsDocuments: easy_customsDocuments_fr,
      easy_crossingDocuments: easy_crossingDocuments_fr,
      easy_crossingInfoBanner: easy_crossingInfoBanner_fr,
      borderPassEasyWithRORO_lifeline: borderPassEasyWithRORO_lifeline_fr,
      borderPassEasyWithRORO_crossingInfoBanner: borderPassEasyWithRORO_crossingInfoBanner_fr,
      borderPassEasyWithRORO_prefolderQualification: borderPassEasyWithRORO_prefolderQualification_fr,

      // customs pass
      customsPass_common: customsPass_common_fr,
      customsPass_lifeline: customsPass_lifeline_fr,
      customsPass_landingPage: customsPass_landingPage_fr,
      customsPass_zendeskForm: customsPass_zendeskForm_fr,
      customsPass_consignments: customsPass_consignments_fr,
      customsPass_servicesOffer: customsPass_servicesOffer_fr,
      customsPass_consentBanner: customsPass_consentBanner_fr,
      customsPass_bookingSummary: customsPass_bookingSummary_fr,
      customsPass_cookiesListPage: customsPass_cookiesListPage_fr,
      customsPass_customsDocuments: customsPass_customsDocuments_fr,
      customsPass_crossingDocuments: customsPass_crossingDocuments_fr,
      customsPass_securityPolicyPage: customsPass_securityPolicyPage_fr,
      customsPass_privacyStatementPage: customsPass_privacyStatementPage_fr,
      customsPass_crossingInfoBannerSummary: customsPass_crossingInfoBannerSummary_fr,

      // borderCrossingRORO
      countries: countries_fr,
      borderCrossingRORO_common: borderCrossingRORO_common_fr,
      borderCrossingRORO_lifeline: borderCrossingRORO_lifeline_fr,
      borderCrossingRORO_newRequest: borderCrossingRORO_newRequest_fr,
      borderCrossingRORO_onBoarding: borderCrossingRORO_onBoarding_fr,
      borderCrossingRORO_haulierEori: borderCrossingRORO_haulierEori_fr,
      borderCrossingRORO_crossingDocuments: borderCrossingRORO_crossingDocuments_fr,
      borderCrossingRORO_crossingInfoBanner: borderCrossingRORO_crossingInfoBanner_fr,
      borderCrossingRORO_prefolderQualification: borderCrossingRORO_prefolderQualification_fr,
      borderCrossingRORO_applicantTransmittedDocuments: borderCrossingRORO_applicantTransmittedDocuments_fr,
    },
    es: {
      common: common_es,
      layouts: layouts_es,
      folders: folders_es,
      components: components_es,
      vehicle_types: vehicle_types_es,

      // border pass easy
      easy_common: easy_common_es,
      easy_lifeline: easy_lifeline_es,
      easy_prefolder: easy_prefolder_es,
      easy_bookingSummary: easy_bookingSummary_es,
      easy_customsDocuments: easy_customsDocuments_es,
      easy_crossingDocuments: easy_crossingDocuments_es,
      easy_crossingInfoBanner: easy_crossingInfoBanner_es,
      borderPassEasyWithRORO_lifeline: borderPassEasyWithRORO_lifeline_es,
      borderPassEasyWithRORO_crossingInfoBanner: borderPassEasyWithRORO_crossingInfoBanner_es,
      borderPassEasyWithRORO_prefolderQualification: borderPassEasyWithRORO_prefolderQualification_es,

      // customs pass
      customsPass_common: customsPass_common_es,
      customsPass_lifeline: customsPass_lifeline_es,
      customsPass_landingPage: customsPass_landingPage_es,
      customsPass_zendeskForm: customsPass_zendeskForm_es,
      customsPass_consignments: customsPass_consignments_es,
      customsPass_servicesOffer: customsPass_servicesOffer_es,
      customsPass_consentBanner: customsPass_consentBanner_es,
      customsPass_bookingSummary: customsPass_bookingSummary_es,
      customsPass_cookiesListPage: customsPass_cookiesListPage_es,
      customsPass_customsDocuments: customsPass_customsDocuments_es,
      customsPass_crossingDocuments: customsPass_crossingDocuments_es,
      customsPass_securityPolicyPage: customsPass_securityPolicyPage_es,
      customsPass_privacyStatementPage: customsPass_privacyStatementPage_es,
      customsPass_crossingInfoBannerSummary: customsPass_crossingInfoBannerSummary_es,

      // borderCrossingRORO
      countries: countries_es,
      borderCrossingRORO_common: borderCrossingRORO_common_es,
      borderCrossingRORO_lifeline: borderCrossingRORO_lifeline_es,
      borderCrossingRORO_newRequest: borderCrossingRORO_newRequest_es,
      borderCrossingRORO_onBoarding: borderCrossingRORO_onBoarding_es,
      borderCrossingRORO_haulierEori: borderCrossingRORO_haulierEori_es,
      borderCrossingRORO_crossingDocuments: borderCrossingRORO_crossingDocuments_es,
      borderCrossingRORO_crossingInfoBanner: borderCrossingRORO_crossingInfoBanner_es,
      borderCrossingRORO_prefolderQualification: borderCrossingRORO_prefolderQualification_es,
      borderCrossingRORO_applicantTransmittedDocuments: borderCrossingRORO_applicantTransmittedDocuments_es,
    },
    de: {
      common: common_de,
      layouts: layouts_de,
      folders: folders_de,
      components: components_de,
      vehicle_types: vehicle_types_de,

      // border pass easy
      easy_common: easy_common_de,
      easy_lifeline: easy_lifeline_de,
      easy_prefolder: easy_prefolder_de,
      easy_bookingSummary: easy_bookingSummary_de,
      easy_customsDocuments: easy_customsDocuments_de,
      easy_crossingDocuments: easy_crossingDocuments_de,
      easy_crossingInfoBanner: easy_crossingInfoBanner_de,
      borderPassEasyWithRORO_lifeline: borderPassEasyWithRORO_lifeline_de,
      borderPassEasyWithRORO_crossingInfoBanner: borderPassEasyWithRORO_crossingInfoBanner_de,
      borderPassEasyWithRORO_prefolderQualification: borderPassEasyWithRORO_prefolderQualification_de,

      // customs pass
      customsPass_common: customsPass_common_de,
      customsPass_lifeline: customsPass_lifeline_de,
      customsPass_landingPage: customsPass_landingPage_de,
      customsPass_zendeskForm: customsPass_zendeskForm_de,
      customsPass_consignments: customsPass_consignments_de,
      customsPass_servicesOffer: customsPass_servicesOffer_de,
      customsPass_consentBanner: customsPass_consentBanner_de,
      customsPass_bookingSummary: customsPass_bookingSummary_de,
      customsPass_cookiesListPage: customsPass_cookiesListPage_de,
      customsPass_customsDocuments: customsPass_customsDocuments_de,
      customsPass_crossingDocuments: customsPass_crossingDocuments_de,
      customsPass_securityPolicyPage: customsPass_securityPolicyPage_de,
      customsPass_privacyStatementPage: customsPass_privacyStatementPage_de,
      customsPass_crossingInfoBannerSummary: customsPass_crossingInfoBannerSummary_de,

      // borderCrossingRORO
      countries: countries_de,
      borderCrossingRORO_common: borderCrossingRORO_common_de,
      borderCrossingRORO_lifeline: borderCrossingRORO_lifeline_de,
      borderCrossingRORO_newRequest: borderCrossingRORO_newRequest_de,
      borderCrossingRORO_onBoarding: borderCrossingRORO_onBoarding_de,
      borderCrossingRORO_haulierEori: borderCrossingRORO_haulierEori_de,
      borderCrossingRORO_crossingDocuments: borderCrossingRORO_crossingDocuments_de,
      borderCrossingRORO_crossingInfoBanner: borderCrossingRORO_crossingInfoBanner_de,
      borderCrossingRORO_prefolderQualification: borderCrossingRORO_prefolderQualification_de,
      borderCrossingRORO_applicantTransmittedDocuments: borderCrossingRORO_applicantTransmittedDocuments_de,
    },
    nl: {
      common: common_nl,
      layouts: layouts_nl,
      folders: folders_nl,
      components: components_nl,
      vehicle_types: vehicle_types_nl,

      // border pass easy
      easy_common: easy_common_nl,
      easy_lifeline: easy_lifeline_nl,
      easy_prefolder: easy_prefolder_nl,
      easy_bookingSummary: easy_bookingSummary_nl,
      easy_customsDocuments: easy_customsDocuments_nl,
      easy_crossingDocuments: easy_crossingDocuments_nl,
      easy_crossingInfoBanner: easy_crossingInfoBanner_nl,
      borderPassEasyWithRORO_lifeline: borderPassEasyWithRORO_lifeline_nl,
      borderPassEasyWithRORO_crossingInfoBanner: borderPassEasyWithRORO_crossingInfoBanner_nl,
      borderPassEasyWithRORO_prefolderQualification: borderPassEasyWithRORO_prefolderQualification_nl,

      // customs pass
      customsPass_common: customsPass_common_nl,
      customsPass_lifeline: customsPass_lifeline_nl,
      customsPass_landingPage: customsPass_landingPage_nl,
      customsPass_zendeskForm: customsPass_zendeskForm_nl,
      customsPass_consignments: customsPass_consignments_nl,
      customsPass_servicesOffer: customsPass_servicesOffer_nl,
      customsPass_consentBanner: customsPass_consentBanner_nl,
      customsPass_bookingSummary: customsPass_bookingSummary_nl,
      customsPass_cookiesListPage: customsPass_cookiesListPage_nl,
      customsPass_customsDocuments: customsPass_customsDocuments_nl,
      customsPass_crossingDocuments: customsPass_crossingDocuments_nl,
      customsPass_securityPolicyPage: customsPass_securityPolicyPage_nl,
      customsPass_privacyStatementPage: customsPass_privacyStatementPage_nl,
      customsPass_crossingInfoBannerSummary: customsPass_crossingInfoBannerSummary_nl,

      // borderCrossingRORO
      countries: countries_nl,
      borderCrossingRORO_common: borderCrossingRORO_common_nl,
      borderCrossingRORO_lifeline: borderCrossingRORO_lifeline_nl,
      borderCrossingRORO_newRequest: borderCrossingRORO_newRequest_nl,
      borderCrossingRORO_onBoarding: borderCrossingRORO_onBoarding_nl,
      borderCrossingRORO_haulierEori: borderCrossingRORO_haulierEori_nl,
      borderCrossingRORO_crossingDocuments: borderCrossingRORO_crossingDocuments_nl,
      borderCrossingRORO_crossingInfoBanner: borderCrossingRORO_crossingInfoBanner_nl,
      borderCrossingRORO_prefolderQualification: borderCrossingRORO_prefolderQualification_nl,
      borderCrossingRORO_applicantTransmittedDocuments: borderCrossingRORO_applicantTransmittedDocuments_nl,
    },
    pl: {
      common: common_pl,
      layouts: layouts_pl,
      folders: folders_pl,
      components: components_pl,
      vehicle_types: vehicle_types_pl,

      // border pass easy
      easy_common: easy_common_pl,
      easy_lifeline: easy_lifeline_pl,
      easy_prefolder: easy_prefolder_pl,
      easy_bookingSummary: easy_bookingSummary_pl,
      easy_customsDocuments: easy_customsDocuments_pl,
      easy_crossingDocuments: easy_crossingDocuments_pl,
      easy_crossingInfoBanner: easy_crossingInfoBanner_pl,
      borderPassEasyWithRORO_lifeline: borderPassEasyWithRORO_lifeline_pl,
      borderPassEasyWithRORO_crossingInfoBanner: borderPassEasyWithRORO_crossingInfoBanner_pl,
      borderPassEasyWithRORO_prefolderQualification: borderPassEasyWithRORO_prefolderQualification_pl,

      // customs pass
      customsPass_common: customsPass_common_pl,
      customsPass_lifeline: customsPass_lifeline_pl,
      customsPass_landingPage: customsPass_landingPage_pl,
      customsPass_zendeskForm: customsPass_zendeskForm_pl,
      customsPass_consignments: customsPass_consignments_pl,
      customsPass_servicesOffer: customsPass_servicesOffer_pl,
      customsPass_consentBanner: customsPass_consentBanner_pl,
      customsPass_bookingSummary: customsPass_bookingSummary_pl,
      customsPass_cookiesListPage: customsPass_cookiesListPage_pl,
      customsPass_customsDocuments: customsPass_customsDocuments_pl,
      customsPass_crossingDocuments: customsPass_crossingDocuments_pl,
      customsPass_securityPolicyPage: customsPass_securityPolicyPage_pl,
      customsPass_privacyStatementPage: customsPass_privacyStatementPage_pl,
      customsPass_crossingInfoBannerSummary: customsPass_crossingInfoBannerSummary_pl,

      // borderCrossingRORO
      countries: countries_pl,
      borderCrossingRORO_common: borderCrossingRORO_common_pl,
      borderCrossingRORO_lifeline: borderCrossingRORO_lifeline_pl,
      borderCrossingRORO_newRequest: borderCrossingRORO_newRequest_pl,
      borderCrossingRORO_onBoarding: borderCrossingRORO_onBoarding_pl,
      borderCrossingRORO_haulierEori: borderCrossingRORO_haulierEori_pl,
      borderCrossingRORO_crossingDocuments: borderCrossingRORO_crossingDocuments_pl,
      borderCrossingRORO_crossingInfoBanner: borderCrossingRORO_crossingInfoBanner_pl,
      borderCrossingRORO_prefolderQualification: borderCrossingRORO_prefolderQualification_pl,
      borderCrossingRORO_applicantTransmittedDocuments: borderCrossingRORO_applicantTransmittedDocuments_pl,
    },
  },
  interpolation: {
    escapeValue: false,
    format: (value, format, lng) => {
      if (isDate(value)) {
        type LocalesKey = keyof typeof locales;
        const locale = locales[lng as LocalesKey];

        if (format === 'short') return formatDate(value, 'P', { locale });
        if (format === 'long') return formatDate(value, 'PPPP', { locale });
        if (format === 'relative') return formatRelative(value, new Date(), { locale });
        if (format === 'ago')
          return formatDistance(value, new Date(), {
            locale,
            addSuffix: true,
          });
        return formatDate(value, format, { locale });
      }
      return value;
    },
  },
});

export default i18next;
